import { useMediaQuery, Theme } from '@material-ui/core';
import { Breakpoint, BreakpointsOptions } from '@material-ui/core/styles/createBreakpoints';
import breakpoints from '../theme/material/breakpoints';

interface IUseBreakpointQuery {
  key: keyof BreakpointsOptions;
  value: Breakpoint | number;
}

const useBreakpointQuery = (props: IUseBreakpointQuery): boolean => {
  const { key, value } = props;

  return useMediaQuery<Theme>(() => breakpoints[key](value));
};

export default useBreakpointQuery;
